export default "__VITE_ASSET__DaaSq8N$__"